import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from '../../services/http.service';
import { ParamsBuilderService } from '../../services/params-builder.service';

@Injectable({
  providedIn: 'root'
})
export class Acceptance194RService {

  constructor(public http: HttpService, public paramsBuilderService: ParamsBuilderService) { }

  getUserTdsAcceptance(): Observable<any> {
    let url = 'ParticipantsTdsAcceptance/getusertdsacceptance';
    return this.http.get(url).pipe(map((response: any) => {
        return response;
    }));
  }
  updateUserTdsAcceptanceStatus(data:any): Observable<any>{
    let url = 'ParticipantsTdsAcceptance/updateusertdsacceptancestatus';
    return this.http.put(url, data).pipe(map((response:any) => {
      return response;
    }));
  }
}
